import React from "react";
import { FormatterType, TeamLogo } from "best-common-react";
import { EmailListRow } from "../types/emailList.ts";
import { MarketingCampaignRow } from "../types/marketing-campaign.ts";
import { formatCreatedAt } from "../util/DateUtil.ts";
import styled from "styled-components";

const CellStyles = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.875rem;
    padding-right: 0.5rem;
    color: #000000;
`;

export const TeamFormatter: React.FC<FormatterType<EmailListRow | MarketingCampaignRow>> = ({ row }) => {
  if (row?.teamId === 1) {
    return <TeamLogo teamId={1} />;
  } else if (!!row?.teamStatsId) {
    return <TeamLogo teamId={row.teamStatsId} />;
  } else {
    return null;
  }
};

export const CreatedAtFormatter: React.FC<FormatterType<EmailListRow | MarketingCampaignRow>> = ({ row }) => {
  return <CellStyles>{formatCreatedAt(row?.createdAt)}</CellStyles>;
};
